import { render, staticRenderFns } from "./Formularios.vue?vue&type=template&id=010b3e9e&scoped=true&"
import script from "./formularios.js?vue&type=script&lang=js&"
export * from "./formularios.js?vue&type=script&lang=js&"
import style0 from "./Formularios.vue?vue&type=style&index=0&id=010b3e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b3e9e",
  null
  
)

export default component.exports